const elevarSubscribe = (customerEmail, customerPhone) => {
  if (window.ElevarDataLayer) {
    if (customerEmail) {
      window.ElevarDataLayer.push({
        event: 'dl_subscribe',
        lead_type: 'email',
        user_properties: {
          customer_email: customerEmail
          // customer_phone: "",
        }
      });
    }
    if (customerPhone) {
      window.ElevarDataLayer.push({
        event: 'dl_subscribe',
        lead_type: 'phone',
        user_properties: {
          //customer_email: customerEmail,
          customer_phone: String(customerPhone)
        }
      });
    }
  }
};

export default elevarSubscribe;
